module.exports = __webpack_public_path__ + "static/media/waterdrop.b40c0c9e.mp3";